<template>
  <div class="contact-info-area pt-100 pb-75">
    <div class="container mw-1356">
      <div class="section-title m-auto text-center">
        <span class="top-title">اتصل بنا</span>
        <h2>يسعدنا دائماً تواصلكم معنا</h2>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6">
          <div class="contact-info-single-item">
            <i class="ti ti-map-2 shapes"></i>
            <i class="ti ti-map-2 icon"></i>
            <h3>مقرنا</h3>
            <p>ألمانيا - متاحون لخدمتكم عالمياً عبر الإنترنت</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="contact-info-single-item">
            <i class="ti ti-phone-call shapes"></i>
            <i class="ti ti-phone-call icon"></i>
            <h3>الهاتف</h3>
            <p>
              <a href="tel:+901234567890">+90 123 456 7890</a>
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="contact-info-single-item">
            <i class="ti ti-mail-bolt shapes"></i>
            <i class="ti ti-mail-bolt icon"></i>
            <h3>البريد الإلكتروني</h3>
            <p>
              <a href="mailto:info@karamtv4k.com">info@iptvservice.com</a>
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "ContactDetails",
});
</script>